<nz-card nzTitle="File Editor" style="margin-top: 15px;">
  <nz-tabs [nzAnimated]="false">

    <!-- Runfile tab -->
    <nz-tab nzTitle="Runfile" [nzForceRender]="true">
      @if (!runfile()) {
        <p class="empty-hint">Select a base runfile above to begin editing.</p>
      } @else if (runfileResource.isLoading()) {
        <p class="status-hint">Loading runfile…</p>
      } @else if (runfileResource.error()) {
        <p class="error-hint">Failed to load runfile.</p>
      } @else if (runfileResource.value()) {
        <app-monaco-diff-editor
          [originalCode]="runfileResource.value().content"
          [(modifiedCode)]="editedRunfileContent"
          [language]="runfileLanguage"
          [markers]="runfileMarkers()"
          height="75vh"
        />
      }
    </nz-tab>

    <!-- env.sh tab -->
    <nz-tab nzTitle="Environment Variables" [nzForceRender]="true">
      @if (!job()) {
        <p class="empty-hint">Select a template job to load env.sh.</p>
      } @else if (envShResource.isLoading()) {
        <p class="status-hint">Loading env.sh…</p>
      } @else {
        @if (envShUnexpectedError()) {
          <nz-alert
            nzType="error"
            nzShowIcon
            nzMessage="Failed to load env.sh"
            [nzDescription]="envShUnexpectedError()?.message || envShUnexpectedError()?.statusText || 'An unexpected error occurred.'"
            style="margin-bottom: 12px;"
          />
        }
        @if (envShResource.error()) {
          <app-monaco-editor
            [(content)]="editedEnvShContent"
            language="shell"
            [markers]="envShMarkers()"
            height="75vh"
          />
        } @else if (envShResource.value()) {
          <app-monaco-diff-editor
            [originalCode]="envShResource.value().content"
            [(modifiedCode)]="editedEnvShContent"
            language="shell"
            [markers]="envShMarkers()"
            height="75vh"
          />
        }
      }
    </nz-tab>

  </nz-tabs>
</nz-card>
